<template>
  <div v-if="!hiddenIcon" class="widget-wrap" ref="wrapperRef" v-on-click-outside="() => isShowPopover = false">
    <div class="contact-btn" @click="isShowPopover = !isShowPopover">
      <svg v-if="!isShowPopover" width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.437 12.3781C14.6793 11.6894 15.1574 11.1086 15.7869 10.7387C16.4163 10.3688 17.1563 10.2336 17.8759 10.357C18.5954 10.4804 19.2481 10.8545 19.7183 11.4131C20.1885 11.9716 20.4458 12.6785 20.4447 13.4086C20.4447 15.4695 17.3532 16.5 17.3532 16.5M17.3931 20.625H17.4069M17.187 27.5C23.6418 27.5 28.8745 22.2673 28.8745 15.8125C28.8745 9.35767 23.6418 4.125 17.187 4.125C10.7322 4.125 5.49948 9.35767 5.49948 15.8125C5.49948 17.1187 5.71377 18.3749 6.10912 19.5478C6.25789 19.9892 6.33228 20.2099 6.3457 20.3795C6.35895 20.5469 6.34893 20.6643 6.30751 20.8271C6.26556 20.9919 6.17295 21.1633 5.98774 21.5061L3.73871 25.669C3.41791 26.2628 3.2575 26.5597 3.2934 26.7888C3.32467 26.9884 3.44214 27.1641 3.6146 27.2693C3.8126 27.3901 4.14827 27.3554 4.8196 27.286L11.861 26.5581C12.0742 26.5361 12.1809 26.5251 12.278 26.5288C12.3736 26.5325 12.4411 26.5414 12.5343 26.5629C12.6291 26.5848 12.7482 26.6307 12.9866 26.7225C14.2901 27.2247 15.7064 27.5 17.187 27.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-if="isShowPopover" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M26.2067 26.2067L8.5 8.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M26.2067 8.5L8.5 26.2067" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div v-if="isShowPopover" class="popover" ref="popoverRef">
      <div class="popover-header">
        <div class="">{{ t('do_you_have_question') }}</div>
        <div class="">{{ t('chat_us') }}</div>
      </div>
      <div class="bottom-arrow">
        <svg width="61" height="15" viewBox="0 0 61 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.55887 5H0L0 0L43.5 0V5H41.4411C35.0759 5 28.9714 7.52856 24.4706 12.0294L21.5 15L18.5294 12.0294C14.0286 7.52856 7.92407 5 1.55887 5Z" fill="white"/>
        </svg>
      </div>
      <div class="faq-btn-group">
        <div class="faq-btn" @click="openChat">
          <v-icon :icon="OnlineChatIcon" size="32" />
          {{ t("online_chat")}}
        </div>
        <a href="https://wa.me/77080000160" target="_blank">
          <div class="faq-btn">
            <WhatsappIcon/>
            Whatsapp
          </div>
        </a>
        <a href="https://t.me/ismetplatform" target="_blank">
          <div class="faq-btn">
            <TelegramIcon/>
            Telegram
          </div>
        </a>
      </div>
      <a class="faq-link-btn" :href="domain+path+'ismet-gid/ismet-docs'" target="_blank">
        <div class="faq-link">
          {{ t('faq')}}
          <v-icon :icon="ChevronRightIcon" size="24" :color="'BW-400-Border'"/>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
// @ts-nocheck
import {ref} from 'vue';
import { useI18n } from 'vue-i18n';
import {vOnClickOutside} from "@vueuse/components";

import {isProd} from "@/shared/lib/utils/environment";
import {openRocketChat} from "@/shared/api/rocketChat";

import WhatsappIcon from '@/app/assets/social/whatsapp.vue';
import TelegramIcon from '@/app/assets/social/telegram.vue';
import OnlineChatIcon from '@/app/assets/social/online_chat.vue';
import ChevronRightIcon from '@/app/assets/icons/chevron_right.vue';

const { t, locale } = useI18n()

const isShowPopover = ref<boolean>(false);
const hiddenIcon = ref<boolean>(false)

const domain = isProd() ? 'https://ismet.kz' : 'https://test.i-smet.kz';
const path = locale.value === 'ru' ? '/ru/' : '/kk/';

const openChat = () => {
  try {
    openRocketChat();
  } catch {
    console.error('[ISMET DOCS] RocketChat is not available. Please ensure the RocketChat script is loaded.')
  }
}

RocketChat(function() {
  this.onWidgetHidden(function() {
    hiddenIcon.value = false;
  });
  this.onWidgetShown(function() {
    hiddenIcon.value = true;
  });
});
</script>

<style scoped lang="sass">
@use '@/app/assets/scss/variables'

.widget-wrap
  position: relative

.contact-btn
  position: fixed
  bottom: 40px
  right: 40px
  z-index: 1000
  height: 64px
  width: 64px
  background: #0D87EF
  border-radius: 100px
  padding: 1rem
  cursor: pointer

.faq-link-btn
  text-decoration: none

.faq-link
  padding: 4px 8px
  display: flex
  font-size: 14px
  justify-content: space-between
  align-items: center
  cursor: pointer
  border-radius: 8px
  color: #363636

  &:hover
    background: #F6F7F8

.bottom-arrow
  position: relative
  svg
    position: absolute
    bottom: -158px
    right: -16px

.faq-btn-group
  display: flex
  gap: 4px
  margin-bottom: 16px
  a
    text-decoration: none
    width: 100%
.faq-btn
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  gap: 8px
  color: #363636
  background: #f6f7f8
  border-radius: 8px
  cursor: pointer
  padding: 12px 13px 8px 13px
  max-height: 76px
  font-size: 13px
  width: 100%
  max-width: 103px
  &:hover
    background: #F0F3F4
  svg
    width: 32px
    height: 32px


.popover
  position: fixed
  bottom: 118px
  right: 32px
  background: white
  border-radius: 16px
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.12)
  z-index: 1001
  width: 100%
  max-width: 350px
  padding: 24px 16px

.popover-header
  display: flex
  flex-direction: column
  font-weight: 600
  font-size: 16px
  margin-bottom: 16px

@media (max-width: variables.$screen_breakpoint_md)
  .widget-wrap
    display: none
</style>

<i18n lang="json">
{
  "ru": {
    "do_you_have_question": "Есть вопрос?",
    "chat_us": "Напишите нам в чат",
    "online_chat": "Онлайн чат",
    "faq": "Часто задаваемые вопросы"
  },
  "kk": {
    "do_you_have_question": "Сұрағыңыз бар ма?",
    "chat_us": "Бізге чат арқылы жазыңыз",
    "online_chat": "Онлайн чат",
    "faq": "Жиі қойылатын сұрақтар"
  }
}
</i18n>
